import { Keycap } from "@/components/keycap/Keycap";
import { StatusBadge } from "@/components/StatusBadge";
import { CtaLink } from "@/components/Button";
import type { Product } from "@/types/content";
import "./ProductFamilyCard.css";

/**
 * One of the five connected product surfaces on /product. Never presented
 * as an independently completed commercial SKU — every card carries the
 * same honest `StatusBadge` vocabulary as the rest of the site.
 */
export function ProductFamilyCard({ product }: { product: Product }) {
  return (
    <article className="product-family-card">
      <div className="capability-card-head">
        <Keycap id={product.keycap} size="lg" />
        <StatusBadge status={product.status} />
      </div>
      <h3 className="product-family-name">{product.name}</h3>
      <p className="product-family-tagline">{product.tagline}</p>
      <ul className="product-family-capabilities">
        {product.capabilities.map((capability) => (
          <li key={capability}>{capability}</li>
        ))}
      </ul>
      <CtaLink to={product.link.to} variant="secondary" className="product-family-link">
        {product.link.label}
      </CtaLink>
    </article>
  );
}
